import { useCallback, useEffect, useRef, useState } from 'react'

import { loadDevModeFromStorage, saveDevModeToStorage } from '../../../../shared/libs/devModePersistence'
import {
  INITIAL_DEV_MODE_CLICK_STATE,
  nextDevModeClickState,
  type DevModeClickState
} from '../helpers/devModeClickCounter'

export interface UseDevModeUnlockResult {
  isDevMode: boolean
  registerClick: () => void
}

/**
 * Tap-to-unlock dev mode. 6 clicks within 3 seconds of each other toggle the
 * `isDevMode` flag, which is persisted to localStorage. Caller binds
 * `registerClick` to whatever element should be the secret-tap target.
 */
export function useDevModeUnlock(): UseDevModeUnlockResult {
  const [isDevMode, setIsDevMode] = useState(() => loadDevModeFromStorage())
  const stateRef = useRef<DevModeClickState>(INITIAL_DEV_MODE_CLICK_STATE)

  useEffect(() => {
    saveDevModeToStorage(isDevMode)
  }, [isDevMode])

  const registerClick = useCallback(() => {
    const { state, shouldToggle } = nextDevModeClickState(stateRef.current, Date.now())
    stateRef.current = state
    if (shouldToggle) setIsDevMode((prev) => !prev)
  }, [])

  return { isDevMode, registerClick }
}
